import React from "react";
import Tooltip from "./InfoTooltip/InfoTooltip";
import InfoIcon from "../icons/InfoIcon";

interface TabDataProps {
  label: string;
  count?: number;
  action?: string;
}

interface TabProps {
  tabData: TabDataProps[];
  activeTab: string;
  setActiveTab: Function;
}

const CustomTabs = ({ tabData, activeTab, setActiveTab }: TabProps) => {
  return (
    <div className="foundit_custom-tab">
      <ul className="foundit_custom-tab_container">
        {tabData.map((element: any, index: any) => {
          let inboundJobs = element.label === 'Inbound_Jobs'
          let isActive = element.label === "Active";
          let label = inboundJobs ? "Sourced Jobs" : isActive ? "My Posted Jobs" : element.label; //Inbound Jobs label changes to Sourced Jobs MCORE-7092
          return <li
            onClick={() => setActiveTab(element.label)}
            className={`foundit_custom-tab_element ${
              activeTab === element.label ? "active" : ""
            } ${inboundJobs ? "inbound_list" : ""}`}
          >
            {label}
            {typeof (element.count) === 'number' && <span> ({element.count})</span>} {
              inboundJobs ? 
              <Tooltip 
              content={<div style={{
                width: '550px',
                display: 'block', 
                height: 'auto',
                wordWrap: 'break-word',
                whiteSpace: 'normal'
              }}>This section includes jobs from publicly available job opportunities for your organization.(Note:-any action on profiles would consume inventory)</div>}
              direction="top"
              >
                 <InfoIcon/>
            </Tooltip> : null
            }
          </li>
        })}
      </ul>
    </div>
  );
};

export default CustomTabs;
